"use client";

import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TheVelvetHorizon() {
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY < window.innerHeight * 1.5) {
        setOffsetY(window.scrollY);
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="232805" id="the-velvet-horizon" className="relative w-full min-h-screen flex flex-col lg:flex-row overflow-hidden dark bg-background text-foreground">
      {}
      <div className="w-full lg:w-[40%] flex flex-col justify-center items-center lg:items-start p-8 lg:p-16 xl:p-24 bg-background z-10 min-h-[50vh] lg:min-h-screen">
        <div className="max-w-md w-full flex flex-col items-center lg:items-start text-center lg:text-left">
          <h1 className="font-default text-7xl md:text-8xl xl:text-[100px] font-bold tracking-tighter text-foreground uppercase leading-[0.85] mb-12">
            The Soul<br />of Soil
          </h1>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild variant="default" className="rounded-md h-14 px-10 text-sm tracking-widest uppercase bg-primary text-primary-foreground hover:bg-primary/90 transition-all shadow-md">
              <Link to="/ShopPage">Explore the Collection</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="w-full lg:w-[60%] h-[60vh] lg:h-screen relative overflow-hidden bg-muted">
        <div className="absolute inset-0 bg-primary/30 z-10 pointer-events-none backdrop-blur-[1px]" />
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/velvet_vineyard_golden_hour.png" alt="Velvet Vineyards Estate at Golden Hour" className="absolute inset-0 w-full h-[120%] object-cover object-center will-change-transform" style={{
        transform: `translateY(-${offsetY * 0.15}px)`
      }} />
      </div>
    </section>;
}